// La columna «Último msg» de Cobranza: días de CDMX desde el último aviso no descartado del crédito.
import { daysBetweenDays, mxDay } from '@/lib/dateHelpers';
import type { InstallmentRow } from './types';

/** Pasados estos días sin contacto la celda se pinta en ámbar. */
export const STALE_LAST_MESSAGE_DAYS = 14;

export type LastMessage =
    | { kind: 'none' }
    | { kind: 'unavailable' }
    | { kind: 'noCredit' }
    | { kind: 'sent'; days: number; label: string; stale: boolean };

/** «hoy», «ayer» o «hace Nd», igual que la celda del mock. */
function relativeDaysLabel(days: number): string {
    if (days === 0) return 'hoy';
    if (days === 1) return 'ayer';
    return `hace ${String(days)}d`;
}

export function lastMessageOf(row: InstallmentRow, today: string): LastMessage {
    if (row.credit === null) return { kind: 'noCredit' };
    if (row.credit.lastNotificationStatus !== 'AVAILABLE') return { kind: 'unavailable' };
    const last = row.credit.lastNotification;
    if (last === null) return { kind: 'none' };
    const days = Math.max(0, daysBetweenDays(today, mxDay(last.sentAt)));
    return {
        kind: 'sent',
        days,
        label: relativeDaysLabel(days),
        stale: days > STALE_LAST_MESSAGE_DAYS,
    };
}

/** Sin mensaje vale -1 como en el mock; `null` es «no se sabe» y el orden lo manda al final. */
export function lastMessageSortValueOf(row: InstallmentRow, today: string): number | null {
    const last = lastMessageOf(row, today);
    if (last.kind === 'sent') return last.days;
    return last.kind === 'none' ? -1 : null;
}
